import { FC, ReactNode } from 'react';
import { Typography } from 'antd';
// import { CheckEmail } from 'assets/svg';

import { Content } from './styled';

const { Title, Paragraph } = Typography;

const MessageEmailCheck: FC<{ children: ReactNode; title: string }> = ({
  title,
  children
}) => {
  return (
    <Content>
      {/* <CheckEmail style={{ marginBottom: 54 }} /> */}
      <Title level={2} style={{ marginBottom: 24 }}>
        {title}
      </Title>
      <Paragraph style={{ fontSize: 16 }}>{children}</Paragraph>
    </Content>
  );
};

export default MessageEmailCheck;
